// Tab „Allgemein“ (design_handoff_profil §3): Persönliche Informationen (nur lesend), Account Status (statisch wie
// bisher) und die Telefonie-Karte.
import type { Icon } from '@phosphor-icons/react';
import { EnvelopeSimple, Fingerprint, Hash, IdentificationBadge, Pulse, ShieldCheck, User } from '@phosphor-icons/react';
import TelefonieKarte from '../../../../components/telefonie/TelefonieKarte';
import type { ProfilDaten } from '../../../../lib/profil/profil';
import { KopfIcon, ProfilWidget, verlauf } from './Bausteine';

function Zeile({ icon: I, label, wert, tip, mono = false, erste = false }: { icon: Icon; label: string; wert?: string | null; tip: string; mono?: boolean; erste?: boolean }) {
  return (
    <div data-tip={tip} className="flex items-center" style={{ gap: 12, padding: '13px 14px', borderTop: erste ? 'none' : '1px solid var(--line)' }}>
      <span className="flex shrink-0 items-center justify-center" style={{ width: 30, height: 30, borderRadius: 9, background: 'var(--fill2)', color: 'var(--ink2)' }}>
        <I size={15} weight="bold" />
      </span>
      <div className="flex min-w-0 flex-1 flex-col" style={{ gap: 1 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink3)' }}>{label}</span>
        <span className="truncate" style={mono
          ? { fontFamily: "'SF Mono', ui-monospace, Menlo, monospace", fontSize: 12.5, fontWeight: 600, color: 'var(--ink2)' }
          : { fontSize: 14.5, fontWeight: 700 }}>{wert}</span>
      </div>
    </div>
  );
}

export function AllgemeinTab({ profil, breit }: { profil: ProfilDaten | null; breit: boolean }) {
  const halb = breit ? 'span 6' : '1 / -1';
  return (
    <div className="grid items-stretch" style={{ gridTemplateColumns: 'repeat(12, minmax(0, 1fr))', gap: 14 }}>
      <ProfilWidget titel="Persönliche Informationen" untertitel="Stammdaten deines Kontos" spalte={halb}
        icon={<KopfIcon flaeche={verlauf('--info')}><User size={19} weight="fill" /></KopfIcon>}>
        <div className="flex flex-col" style={{ borderRadius: 20, background: 'var(--fill)', boxShadow: 'inset 0 0 0 1px var(--line)' }}>
          <Zeile erste icon={IdentificationBadge} label="Vollständiger Name" wert={profil?.full_name} tip="Vollständiger Name – Wird im Portal und in E-Mails angezeigt" />
          <Zeile icon={EnvelopeSimple} label="E-Mail Adresse" wert={profil?.email} tip="E-Mail Adresse – Login und Benachrichtigungen" />
          <Zeile icon={Hash} label="Interne ID" wert={profil?.id} mono tip="Interne ID – Technische Kennung, z. B. für den Support" />
        </div>
      </ProfilWidget>

      <ProfilWidget titel="Account Status" untertitel="Verifizierung und Anmeldung" spalte={halb}
        icon={<KopfIcon flaeche={verlauf('--ok')}><Pulse size={19} weight="fill" /></KopfIcon>}>
        <div data-tip="Sicherheitstufe – Angezeigter Status, keine Einstellung" className="flex flex-1 items-center" style={{ gap: 14, padding: 16, borderRadius: 20, background: 'var(--ok-soft)' }}>
          <span className="flex shrink-0 items-center justify-center" style={{ width: 46, height: 46, borderRadius: '50%', background: 'var(--ok)', color: '#fff', boxShadow: '0 10px 22px -10px var(--ok)' }}>
            <ShieldCheck size={24} weight="fill" />
          </span>
          <div className="flex min-w-0 flex-col" style={{ gap: 2 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ok)' }}>Sicherheitstufe</span>
            <span style={{ fontSize: 16, fontWeight: 800 }}>Admin-Verifiziert</span>
          </div>
        </div>
        <div data-tip="Biometrischer Login – Anmeldung per Fingerabdruck oder Face ID ist nicht eingerichtet" className="flex items-center"
          style={{ gap: 14, padding: '14px 16px', borderRadius: 20, background: 'var(--fill)', boxShadow: 'inset 0 0 0 1px var(--line)' }}>
          <span className="flex shrink-0 items-center justify-center" style={{ width: 38, height: 38, borderRadius: '50%', background: 'var(--fill2)', color: 'var(--ink3)' }}>
            <Fingerprint size={20} weight="bold" />
          </span>
          <div className="flex min-w-0 flex-1 flex-col" style={{ gap: 1 }}>
            <span style={{ fontSize: 14, fontWeight: 800 }}>Biometrischer Login</span>
            <span style={{ fontSize: 12.5, color: 'var(--ink3)' }}>Nicht konfiguriert</span>
          </div>
        </div>
      </ProfilWidget>

      <TelefonieKarte />
    </div>
  );
}
